import { render, staticRenderFns } from "./Pageconfigure.vue?vue&type=template&id=3aa3425c&scoped=true"
import script from "./Pageconfigure.vue?vue&type=script&lang=js"
export * from "./Pageconfigure.vue?vue&type=script&lang=js"
import style0 from "./Pageconfigure.vue?vue&type=style&index=0&id=3aa3425c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3425c",
  null
  
)

export default component.exports